import { RANGE_OF_EMPLOYEES } from "../../../constants/enums/range-of-employees";
import { getDateFormat } from "../constants";
import { PhaseOneParameters } from "./PhaseOne";

export class PhaseGetCustomer {
    KeyContactId: number;
    StatusCode: string;
    chOrigen_c: string;
    chFuente_c: string;
    chECPriorizacionEstado_c: string;
    chECAutoTipifEstado_c: string;
    chECEnvioEstado_c: string;
    tECId_c: string;
    tECFrom_c: string;
    dEC_c: string;
    cECMonto_c: number;
    cVidaLeyEstimadoAnual_c: number;
    cVidaLeyEstimadoSemestral_c: number;
    chECCanal_c: string;
    chTipifArbol_c: string;
    chTipifProducto_c: string;
    chECFase_c: string;
    tPerNumDoc_c: string;
    chPerTipoDoc_c: string;
    tPerNombre_c: string;
    tPerApellidoPaterno_c: string;
    tPerApellidoMaterno_c: string;
    tPerCorreoElectronico_c: string;
    tPerTelefonoCelular_c: string;
    chVidaLeyNumTrabajadores_c: typeof RANGE_OF_EMPLOYEES;
    ChildRevenue: any;
    constructor({
        channel,
        ruc,
        name,
        lastName,
        email,
        phone,
        range,
        amount,
        annualPrice,
        semesterPrice,
        partyId,
        from,
    }: PhaseOneParameters) {
        this.KeyContactId = partyId;
        this.StatusCode = "OPEN";
        this.cECMonto_c = amount;
        this.cVidaLeyEstimadoAnual_c = annualPrice;
        this.cVidaLeyEstimadoSemestral_c = semesterPrice;
        this.chOrigen_c = "1831";
        this.chFuente_c = "PV_API_EC";
        this.chECPriorizacionEstado_c = "solicitar";
        this.chECAutoTipifEstado_c = "solicitar";
        this.chECEnvioEstado_c = "solicitar";
        this.tECId_c = `${Number.parseInt(
            Math.floor(100000 + Math.random() * 900000)
                .toString()
                .substring(0, 6),
            10
        )}`;
        this.tECFrom_c = from || "?from=cotizaVidaLey";
        this.dEC_c = getDateFormat();
        this.chECCanal_c = channel;
        this.chTipifArbol_c = "EC";
        this.chTipifProducto_c = "VIDA_LEY_EC";
        this.chECFase_c = "precotizacion";
        this.tPerNumDoc_c = ruc;
        this.chPerTipoDoc_c = "2";
        this.tPerNombre_c = "";
        this.tPerApellidoPaterno_c = `${name ?? ""} ${lastName}`;
        this.tPerApellidoMaterno_c = "";
        this.tPerCorreoElectronico_c = email;
        this.tPerTelefonoCelular_c = `+51 ${phone}`;
        this.chVidaLeyNumTrabajadores_c = range;
        this.ChildRevenue = [
            {
                ItemNumber: "VIDA_LEY",
                chProducto_c: "VIDA_LEY",
            },
        ];
    }
}

export class PhaseCreateCustomer {
    FirstName: string;
    PersonDEO_chTipoPersona_c: string;
    PersonDEO_chTipoDoc_c: string;
    PersonDEO_tNumDoc_c: string;
    ContactPoint: any;
    constructor({ name, ruc, phone, email }: PhaseOneParameters) {
        this.FirstName = name;
        this.PersonDEO_chTipoPersona_c = ruc.startsWith("10") ? "1" : "2";
        this.PersonDEO_chTipoDoc_c = "2";
        this.PersonDEO_tNumDoc_c = ruc;
        this.ContactPoint = [
            {
                ContactPointType: "PHONE",
                PrimaryFlag: "Y",
                PhoneNumber: phone,
                PhoneType: "MOBILE",
                PhoneAreaCode: 1,
                PhoneCountryCode: "51",
            },
            {
                ContactPointType: "EMAIL",
                EmailAddress: email,
            },
        ];
    }
}
